import React from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { BaseComponent } from '../../../components/BaseComponent';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Check, Left } from '../../../components/Icon';
import { ProductInvoiceTableComp } from './ProductInvoiceTable';
import styled from 'styled-components';
import { PageHeader } from '../../../components/PageHeader';
import { Loader } from '../../../components/Loader';
import { Card } from '../../../components/Card';
import { FormField } from '../../../components/FormFields';
import { Input } from '../../../components/Input';
import { LedgersPosting } from '../../Invoices/components/Ledgers/LedgersPosting';
import { InvoiceFinalizationStatusBar } from '../../Invoices/components/InvoiceFinalizationStatusBar';
import { addApiError } from '../../Api/actions';
import { CompanyInfoCard } from './CompanyInfoCard';
import { ProductInvoiceInfoCard } from './ProductInvoiceInfoCard';
import { CompanyDocumentsCard } from '../../Companies/components/CardDocuments';
import { InvoiceSubjectsCard } from '../../Invoices/components/IncomingInvoice/CardInvoiceSubjects';
import { CreditInvoiceModal } from '../../Invoices/components/CreditInvoiceModal';
import {
  createCreditInvoice,
  deleteInvoice,
  deleteProductInvoice,
  fetchInvoice,
  finalizeV2,
  initiateInvoiceEdit,
  initiateNewInvoiceValue,
  removeInvoiceSubject,
  retryFinalizationV2,
  updateInvoice,
  updateInvoiceEmailData,
  updateInvoiceV2,
} from '../../Invoices/actions';
import { fetchVehicle } from '../../Vehicles/actions';
import { selectInvoice, selectNewInvoice } from '../../Invoices/selectors';
import { selectVehicle } from '../../Vehicles/selectors';
import { selectProducts } from '../selectors';
import { selectConfig, selectWork, selectWorks } from '../../Api/selectors';
import { REQUEST_VEHICLE } from '../../Vehicles/constants';
import { REQUEST_ADD_DOCUMENT } from '../../Companies/constants';
import { getFinalizationStatus } from '../../Invoices/helpers';
import {
  FINALIZATION_STATUSES,
  INVOICE_DIRECTIONS,
  INVOICE_TYPES,
  REQUEST_INVOICE,
  REQUEST_INVOICE_DELETE,
  REQUEST_UPDATE_INVOICE_V2,
} from '../../Invoices/constants';
import { ProductsOverviewTable } from './ProductsOverviewTable';
import { ProductSubjectDetails } from './ProductSubjectDetails';
import { ProductInvoiceEmailModal } from './productInvoiceEmailModal';
import { DeleteInvoiceModal } from '../../Invoices/components/DeleteInvoiceModal';
import { InvoiceQuizModal } from '../../Invoices/components/InvoiceQuizModal';
import { AUTOHUISSALLAND_INSTALATION } from '../../../containers/App/constants';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import styles from './ProductInvoice.module.css';
import { getDate } from '../../Vehicles/helpers';
import { LoadingWithNotification } from '../../../components/LoadingWithNotification/LoadingWithNotification';
import { Modal } from '../../../components/Modal';
import CreditInvoiceEmailModal from '../../Invoices/components/IncomingInvoice/CreditInvoiceEmailModal';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import { ProductAndCostsModal } from '../../Invoices/components/ProductsAndCostsModal';

const Container = styled.div`
  display: grid;
  grid-template-columns: 25% 75%;
  margin-bottom: 30px;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 100%;
  }
  h3 {
    font-size: 20px;
    font-weight: 500;
  }

  .vbox.col {
    width: auto;

    @media (max-width: 768px) {
      max-width: 100%;
    }
  }

  .ledgers-wrapper {
    max-width: 100%;
    margin: 6px;
    padding: 5px;
    background-color: #fff;
  }

  .info-card {
    width: 98%;
    button {
      margin-bottom: 4px;
    }
  }

  .info-card.wide {
    width: 100%;
    height: 100%;
  }

  .fixedHeight {
    max-height: 600px;
    overflow-y: auto;
  }
`;

const ButtonCardContainer = styled.div`
  width: 100%;
  font-size: 14px;

  .type {
    color: #6c757d;
  }
  .info-card.fixedWeight {
    width: 98%;
  }
`;

const Success = styled.div`
  color: green;
`;

const STATE = {
  showEmailModal: false,
  showCreditModal: false,
  edit: false,
  showDeleteModal: false,
  showQuizDelete: false,
};

export class ProductInvoiceComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetchInvoice();
    this.props.vehicleId && this.props.fetchVehicle();
    this.props.init();
    this.props.initiateValues(['id', 'date', 'dueDate', 'paidDate', 'financialTotalAmount', ...this.getCompanyTypes(true)]);
  }

  handleAddNewProductToInvoiceClick = () => {
    this.setState({ showAddProduct: true });
  };

  get products() {
    return this.invoice?.invoiceSubjects
      ?.filter(sub => sub.type == 'product')
      .map(p => {
        let originalPrice = '';
        let quantity = p?.product?.isOneTime == 1 ? p?.one_time : p?.one_time && p?.one_time > 1 ? p?.one_time : p?.counter;
        if (!p?.product?.id && p?.one_time) {
          quantity = p?.one_time;
        }
        if (+p?.product_price_excl_vat_per_item) {
          originalPrice = +p?.product_price_excl_vat_per_item;
        }
        const parsedProduct = {
          id: p?.id,
          name: p?.description ?? p?.product?.name,
          description: p?.product?.description ?? p?.description,
          purchasePriceExclVat: originalPrice,
          salesPriceExclVat: originalPrice,
          totalPriceExclVat: p?.product_price_excl_vat,
          quantity,
        };
        return parsedProduct;
      });
  }

  get currentSubject() {
    return this.invoice?.invoiceSubjects?.find(sub => sub?.id == this.state.currentSubjectId) ?? {};
  }

  get vehicle() {
    return this.props.vehicle;
  }

  get invoice() {
    return this.props.invoice;
  }

  get targetCompany() {
    const company =
      this.invoice?.direction == INVOICE_DIRECTIONS.INCOMING ? this.invoice?.incomingCompany : this.invoice?.outgoingCompany;
    return company;
  }

  get exportedAtMsg() {
    return <InvoiceFinalizationStatusBar invoice={this.invoice} />;
  }

  get editDisabled() {
    return !!this.props.invoice.finalizationStatus || this.invoice.isFinal;
  }

  get refNr() {
    return this.state.reNrChanged ? this.state.referenceNumber : this.invoice.referenceNumber;
  }

  get dto() {
    let isFinal = this.props.invoice?.isFinal;
    const direction = this.props.invoice?.direction;
    const importValue =
      this.props.invoice?.vehicle?.import === true || this.props.invoice?.vehicle?.import == '1' ? '1' : '0';

    return {
      date: getDate(this.props.values?.date),
      desiredDeliveryDate: null,
      direction,
      entryNumber: this.props.invoice?.entryNumber,
      discount: this.props.invoice?.discount || null,
      dueDate: this.props.values?.dueDate,
      economicalTotalAmount: null,
      financialTotalAmount: this.props.values?.financialTotalAmount,
      isFinal,
      paidDate: this.props.values?.paidDate,
      payments: null,
      incoming: null,
      statusId: this.props.invoice?.statusId,
      type: this.props.invoice?.type,
      userCreatorId: this.props.invoice?.userCreatorId,
      incomingCompanyId: this.props.invoice?.incomingCompanyId,
      outgoingCompanyId: this.props.invoice?.outgoingCompanyId,
      transportLocationId: this.props.invoice?.transportLocationId ?? null,
      referenceNumber: this.props.invoice?.referenceNumber,
      invoiceSubjects: this.props.invoice?.invoiceSubjects,

      vehicle: {
        ...this.props.invoice?.vehicle,
        import: importValue,
      },

      company: {
        IBAN: this.props.values?.IBAN,
        BTW_number: this.props.values?.BTW_number?.replace(/\s/g, '')?.toUpperCase(),
        customernumber: this.props.values?.customernumber,
      },
    };
  }

  getCompanyTypes(isCreditor) {
    let types = [];
    if (isCreditor) {
      types = ['financial_contact', 'company_from_eu', 'BTW_number', 'iban', 'customernumber'];
    }

    return types;
  }

  to(url, newWindow) {
    //
    if (newWindow) {
      window.open(url);
    } else {
      this.props.history.push(url);
    }
  }

  onSubjectComplete() {
    this.setState({ showAddProduct: false });
    this.to(`/invoices/product-invoices/vehicle/${this.props.vehicleId}/invoice/${this.props.invoiceId}`);
  }

  onSubjectUpdateComplete() {
    this.setState({ showEditProduct: false });
    this.to(`/invoices/product-invoices/vehicle/${this.props.vehicleId}/invoice/${this.props.invoiceId}`);
  }

  showCreditModal() {
    this.setState({ showCreditModal: true });
  }

  showCreditAndCopyModal = () => {
    this.setState({ showCreditModal: true, copyAfterCredit: true });
  };

  onConfirmCreditModal() {
    this.setState(
      { showCreditModal: false },
      this.props.createCreditInvoice(result => {
        if (typeof result === 'number' && this.state.copyAfterCredit) {
          this.setState({ showCopyInvoiceModal: true });
          return;
        }
      }),
    );
  }

  onCancelCreditModal() {
    this.setState({ showCreditModal: false, copyAfterCredit: false });
  }

  onEmailModalComplete(dto) {
    this.setState({ showEmailModal: false }, () => {
      this.props.updateInvoiceEmailData(dto, response => {
        if (response.validationErrors) {
          let errorMsg = 'general';
          if (response.validationErrors) {
            errorMsg = Object.values(response.validationErrors[0]?.constraints ?? {})[0] ?? '';
          }
          this.props.addApiError(errorMsg);
        } else {
          this.props.finalizeV2();
        }
      });
    });
  }

  onUpdateRefNr() {
    const dto = {
      referenceNumber: this.refNr,
    };
    this.props.updateInvoice(dto);
  }

  onRefNrChanged(evt) {
    this.setState({
      reNrChanged: true,
      referenceNumber: evt.target.value,
    });
  }

  onUpdate(data) {
    let dto = this.dto;

    if (data) {
      let productsDto = data.products?.map(p => {
        return {
          ...p.currentSubject,
          id: p?.id,
          type: 'product',
          product_price_excl_vat_per_item: p.product_price_excl_vat_per_item,
          product_price_incl_vat_per_item: p.product_price_incl_vat_per_item,
          one_time: p?.one_time ?? p?.one_time_manual,
          product_id: p.product_id,
          // product_price_excl_vat: p.product_price_excl_vat_per_item * +p?.one_time,
          product_price_incl_vat: +p?.product_price_incl_vat_per_item * +p?.one_time ?? +p?.one_time_manual,
          product_price_excl_vat: +p?.product_price_excl_vat,
          price: (+p?.product_price_incl_vat_per_item * +p?.one_time ?? +p?.one_time_manual) || p.currentSubject?.price,
        };
      });
      let manualProductsDto = data.oneTimeProducts?.map(p => {
        let subject = {
          type: 'product',
          product_price_excl_vat_per_item: p.product_price_excl_vat_per_item,
          product_price_incl_vat_per_item: p.product_price_incl_vat_per_item,
          product_price_excl_vat: +p.product_price_excl_vat_per_item * +p?.one_time,
          product_price_incl_vat: +p.product_price_incl_vat_per_item * +p?.one_time,
          price: +p.product_price_incl_vat_per_item * +p?.one_time,
          subjectVat: p.subjectVat,
          one_time: p?.one_time,
          ledger: p.ledger,
          description: p.description,
          ...p,
        };

        if (p.currentSubject) {
          subject = { ...p.currentSubject, ...subject, id: p.currentSubject?.id };
        }

        return subject;
      });
      dto.invoiceSubjects = [...productsDto, ...manualProductsDto];
    }

    this.props.update(dto, result => {
      this.setState({ showAddProductModal: false, edit: false, currentSubjectId: null });
    });
  }

  finalize() {
    return this.props.updateInvoice({ ...this.props.invoice, isFinal: true });
  }

  finalizeV2() {
    const emailIsOptional = !![AUTOHUISSALLAND_INSTALATION.APP_CLIENT_ID].includes(this.props.serverConfig.appClientId);
    if (
      !this.invoice.emailTo &&
      !this.invoice.emailContactId &&
      !this.invoice.financialContactId &&
      this.invoice.direction === INVOICE_DIRECTIONS.OUTGOING &&
      !emailIsOptional
    ) {
      this.setState({ showEmailModal: true });
      return;
    }

    if (this.invoice.direction === INVOICE_DIRECTIONS.OUTGOING && this.invoice.type === INVOICE_TYPES.CREDIT) {
      this.setState({ showCreditInvoiceEmailModal: true });
      return;
    }
    this.props.finalizeV2();
  }

  renderCreditModal() {
    return (
      this.state.showCreditModal && (
        <CreditInvoiceModal
          onConfirm={this.onConfirmCreditModal.bind(this)}
          onCancel={this.onCancelCreditModal.bind(this)}
        />
      )
    );
  }

  resetCreditInvoiceEmailModal() {
    this.setState({ showCreditInvoiceEmailModal: false, sendToTargetEmail: null, manualEmail: '' });
  }

  renderCreditInvoiceEmailModal() {
    const skipEmail = () => {
      let dto = this.dto;
      dto.skipEmail = true;
      this.props.update(dto, result => {
        if (result?.id) {
          this.props.finalizeV2();
          this.resetCreditInvoiceEmailModal();
        }
      });
    };

    if (this.props.work)
      return (
        <Modal>
          <HBox center vCenter>
            <Loader />
          </HBox>
        </Modal>
      );

    return (
      <CreditInvoiceEmailModal
        invoice={this.invoice}
        sendToTargetEmail={this.state.sendToTargetEmail}
        manualEmail={this.state.manualEmail}
        updateInvoiceEmailData={this.props.updateInvoiceEmailData}
        skipEmail={skipEmail}
        addApiError={this.props.addApiError}
        finalizeV2={this.props.finalizeV2}
        setSendToTargetEmail={value => this.setState({ sendToTargetEmail: value })}
        setManualEmail={value => this.setState({ manualEmail: value })}
        manualEmailValue={this.state.manualEmail}
        lbl={this.lbl.bind(this)}
        resetCreditInvoiceEmailModal={this.resetCreditInvoiceEmailModal.bind(this)}
      />
    );
  }

  renderFinalizeBtn() {
    const status = getFinalizationStatus(this.props.invoice);
    if (FINALIZATION_STATUSES.READY_TO_INITIATE === status)
      return (
        <ButtonComponent style="ButtonSoftPrimary" onClick={this.finalizeV2.bind(this)}>
          {this.lbl('invoice.details.finalizeV2Btn')}
        </ButtonComponent>
      );

    if (FINALIZATION_STATUSES.DONE === status)
      return (
        <ButtonComponent style="ButtonSoftPrimary" disabled={true} onClick={this.finalizeV2.bind(this)}>
          {this.lbl('invoice.details.finalizeV2Btn')}
        </ButtonComponent>
      );

    if (FINALIZATION_STATUSES.IN_PROGRESS === status)
      return (
        <ButtonComponent style="ButtonSoftPrimary" disabled={true} onClick={this.finalizeV2.bind(this)}>
          {this.lbl('invoice.details.finalizeV2Btn')}
        </ButtonComponent>
      );

    if (FINALIZATION_STATUSES.ERROR === status)
      return (
        <ButtonComponent style="ButtonSoftPrimary" onClick={this.props.retryFinalizationV2.bind(this)}>
          {this.lbl('invoice.details.retryFinalizeV2Btn')}
        </ButtonComponent>
      );

    return '';
  }

  renderPaymentRefField() {
    return (
      this.invoice.direction === INVOICE_DIRECTIONS.INCOMING && (
        <VBox>
          <p>{this.lbl('invoice.details.referenceNumber')}</p>
          <FormField>
            <Input
              name="referenceNumber"
              value={this.refNr ?? ''}
              onChange={this.onRefNrChanged.bind(this)}
              disabled={this.editDisabled}
              rightDecoration={
                this.state.reNrChanged && (
                  <Button small onClick={this.onUpdateRefNr.bind(this)}>
                    {this.lbl('save')} <Check />
                  </Button>
                )
              }
            />
          </FormField>
        </VBox>
      )
    );
  }

  renderEntryNumber() {
    return (
      this.props?.invoice?.entryNumber && (
        <h3 className={styles.entryNumber}>Entry number: {this.props?.invoice?.entryNumber}</h3>
      )
    );
  }

  renderAddProductModal() {
    return (
      <ProductAndCostsModal
        step="2"
        onConfirm={data => {
          this.onUpdate(data);
        }}
        editInvoice={this.props.invoice?.id}
        reset={() => {
          this.setState({ showAddProductModal: false, edit: false, currentSubjectId: null });
        }}
        copiedSubjects={this.invoice?.invoiceSubjects}
      />
    );
    // return (
    //   <ProductSubjectDetails
    //     invoice={this.invoice}
    //     vehicle={this.vehicle}
    //     vehicleId={this.props.vehicleId}
    //     editMode={this.state.edit || false}
    //     currentSubject={this.state.currentSubjectId ? this.currentSubject : null}
    //     onClose={() => {
    //       this.setState({ showAddProductModal: false, edit: false, currentSubjectId: null });
    //     }}
    //     companyId={this.companyId}
    //     taxRegion={this.props?.values?.company_from_eu}
    //   />
    // );
  }

  addProduct(option, currentSubjectId = null) {
    this.setState({
      showAddProductModal: true,
      edit: option == 'edit' ? true : false,
      currentSubjectId: option == 'edit' ? currentSubjectId : null,
    });
  }

  renderAddManualProductModal() {
    return (
      <AddOneTimeProductModal
        secondaryManualProducts={[]}
        onComplete={this.onCompleteManualProduct.bind(this)}
        onClose={() => {
          this.setState({
            showAddManualProductModal: false,
          });
        }}
      />
    );
  }

  addManualProduct() {
    this.setState({ showAddManualProductModal: true });
  }

  onCompleteManualProduct(manualProduct) {
    const product_price_excl_vat_per_item = stringToNumber(manualProduct?.price_excl_vat);
    const product_price_incl_vat_per_item = stringToNumber(manualProduct?.price_incl_vat);
    const one_time = stringToNumber(manualProduct?.one_time);
    const product_price_excl_vat = product_price_excl_vat_per_item;
    const product_price_incl_vat = product_price_incl_vat_per_item;
    const data = {
      description: manualProduct?.description,
      price: +manualProduct?.price,
      one_time,
      product_price_excl_vat,
      product_price_incl_vat,
      type: INVOICE_SUBJECT_TYPES.PRODUCT,
      vehicleId: this.props.vehicleId || null,
      subjectVat: { code: manualProduct?.vat_code },
      manuallyCreated: true,
      ledger: manualProduct?.ledger ?? null,
    };

    this.props.addSubjectOneTimeProduct(data, res => {
      this.setState({
        showAddManualProductModal: false,
      });
    });
  }

  showDeleteModal = () => {
    this.setState({ showDeleteModal: true });
  };

  renderDeleteModal() {
    return (
      this.state.showDeleteModal && (
        <DeleteInvoiceModal
          onConfirm={this.onConfirmDeleteModal.bind(this)}
          onCancel={this.onCancelDeleteModal.bind(this)}
        />
      )
    );
  }
  onConfirmDeleteModal() {
    this.setState({ showDeleteModal: false, showQuizDelete: true });
  }

  onCancelDeleteModal() {
    this.setState({ showDeleteModal: false });
  }

  sendDeleteRequest = properties => {
    const vehicleId = this.invoice?.vehicle?.id;
    this.setState({ showQuizDelete: false }, this.props.deleteInvoice(properties, this.redirectAfterDelete, vehicleId));
  };

  redirectAfterDelete = () => {
    if (this.props.vehicleId) {
      return this.to(`/vehicles/${this.props.vehicleId}`);
    } else {
      return this.to(`/invoices`);
    }
  };

  redirectAfterDelete = () => {
    if (this.invoice?.vehicle?.id) {
      return this.to(`/vehicles/${this.invoice?.vehicle?.id}`);
    } else {
      return this.to(`/invoices`);
    }
  };

  get companyId() {
    return this.props.invoice?.companyForAccounting?.id;
  }

  render() {
    if (!this.props.invoice || (this.props.vehicleId && !this.props.vehicle)) return '';
    if (this.props.work) return <Loader small />;
    if (this.props.workDelete) {
      return <LoadingWithNotification message={this.lbl('invoice.details.delete_order_notification')} />;
    }

    return (
      <>
        <PageHeader
          title={
            <div
              className="pointer"
              onClick={
                () => this.to('/invoices')
                // this.props.vehicleId
                //   ? this.to(`/invoices/product-invoices/vehicle/${this.props.vehicleId}`)
                //   : this.props.history.goBack()
              }
            >
              <Left />
              {this.lbl('vehicle.details.invoices.title')}
            </div>
          }
        />
        {this.renderDeleteModal()}
        {!!this.state.showQuizDelete && (
          <InvoiceQuizModal
            direction={this.invoice.direction}
            vehicle={this.vehicleSubject?.vehicle}
            onConfirm={this.sendDeleteRequest}
            onCancel={this.onCancelQuiz}
          />
        )}
        {this.renderEntryNumber()}
          {this.state.showAddProductModal && this.renderAddProductModal()}
        <Container>
          {this.renderCreditModal()}
          <VBox left top>
            <ProductInvoiceInfoCard
              types={['id', 'date', 'dueDate', 'paidDate', 'financialTotalAmount']}
              vehicle={this.props.vehicle}
            />
            <ButtonCardContainer>
              <Card className="vehicle-info-card info-card info fixedWeight">
                {this.renderPaymentRefField()}

                <ButtonComponent
                  style="ButtonSoftEditFullWidth"
                  disabled={this.props.calcWork || !!this.props.invoice.finalizationStatus}
                  onClick={() => this.onUpdate()}
                >
                  {this.lbl('invoice.details.updateBtn')}
                </ButtonComponent>

                {this.renderFinalizeBtn()}
                {this.exportedAtMsg}
                <ButtonComponent
                  style="ButtonSoftDelete"
                  disabled={this.invoice?.isFinal}
                  warning
                  onClick={this.showDeleteModal}
                >
                  {this.lbl('invoice.details.deleteOrderBtnOpt')}
                </ButtonComponent>
                <ButtonComponent
                  style="ButtonSoftDelete"
                  disabled={
                    this.invoice?.type !== INVOICE_TYPES.INVOICE ||
                    !this.invoice?.exportedAt ||
                    this.invoice?.creditInvoiceId
                  }
                  onClick={this.showCreditModal.bind(this)}
                  warning
                >
                  {this.lbl('invoice.details.creditBtn')}
                </ButtonComponent>
                <ButtonComponent
                  disabled={
                    this.invoice?.type !== INVOICE_TYPES.INVOICE ||
                    !this.invoice?.exportedAt ||
                    this.invoice?.creditInvoiceId
                  }
                  onClick={this.showCreditAndCopyModal}
                  style="ButtonSoftDelete"
                >
                  {this.lbl('invoice.details.creditAndCopyBtn')}
                </ButtonComponent>
                {this.state.showCopyInvoiceModal && (
                  <ModalComponent onClose={this.setStateFn({ showCopyInvoiceModal: false })}>
                    <HBox center>
                      <ButtonComponent
                        style={'ButtonSoftEdit'}
                        // disabled={this.invoice?.type !== INVOICE_TYPES.INVOICE || !this.invoice?.exportedAt}
                        onClick={this.tofn(`/invoices/product/${this.invoice.direction}/create-copy/${this.invoice?.id}`)}
                        primary
                      >
                        {this.lbl('invoice.details.copy_invoice')}
                      </ButtonComponent>
                    </HBox>
                  </ModalComponent>
                )}
              </Card>
            </ButtonCardContainer>

            {this.props.workAddDocs ? (
              <Loader small />
            ) : (
              <CompanyDocumentsCard isInvoice={true} company={this.targetCompany} />
            )}
            {window.innerWidth <= 768 && (
              <CompanyInfoCard types={this.getCompanyTypes(true)} invoice={this.invoice} company={this.targetCompany} />
            )}
          </VBox>
          <VBox top left>
            <HBox left>
              {window.innerWidth > 768 && (
                <CompanyInfoCard types={this.getCompanyTypes(true)} invoice={this.invoice} company={this.targetCompany} />
              )}
              <div style={{ height: '410px', width: '100%' }}>
                <Card className="vehicle-info-card info-card info wide">
                  <ProductsOverviewTable
                    productInvoicePage
                    invoiceId={this.invoice?.id}
                    addProduct={this.addProduct.bind(this)}
                    vehicleId={this.props.vehicleId}
                    productSubjects={this.products}
                    direction={this.invoice?.direction}
                    companyId={this.companyId}
                    disabled={this.invoice?.isFinal}
                  />
                </Card>
              </div>
            </HBox>
            <HBox className={styles.ledgersContainer}>
              <VBox left top>
                <Card className="vehicle-info-card info-card info wide ">
                  <HBox style={{ paddingBottom: '20px' }} className={'fixedHeight'}>
                    <LedgersPosting
                      smallTable={true}
                      invoice={this.invoice}
                      ledgersEntry={this.invoice.ledgersEntry}
                    ></LedgersPosting>
                  </HBox>
                </Card>
              </VBox>
            </HBox>
          </VBox>
          {this.state.showEmailModal && (
            <ProductInvoiceEmailModal
              invoice={this.invoice}
              onComplete={this.onEmailModalComplete.bind(this)}
              onClose={() => this.setState({ showEmailModal: false })}
            />
          )}
          {this.state.showCreditInvoiceEmailModal && this.renderCreditInvoiceEmailModal()}
        </Container>
      </>
    );
  }
}

ProductInvoiceTableComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onItemClick: PropTypes.func,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    vehicle: selectVehicle(ownProps.vehicleId),
    work: selectWorks([REQUEST_INVOICE, REQUEST_VEHICLE, REQUEST_UPDATE_INVOICE_V2]),
    workAddDocs: selectWork(REQUEST_ADD_DOCUMENT),
    workDelete: selectWork(REQUEST_INVOICE_DELETE),
    products: selectProducts(),
    invoice: selectInvoice(),
    values: selectNewInvoice(),
    serverConfig: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    update(dto, callback) {
      dispatch(updateInvoiceV2(ownProps.invoiceId, dto, callback));
    },
    init() {
      dispatch(initiateInvoiceEdit(ownProps.invoiceId));
    },
    initiateValues(values) {
      values.map(type => dispatch(initiateNewInvoiceValue(type)));
    },
    fetchVehicle: () => {
      dispatch(fetchVehicle(ownProps.vehicleId));
    },
    fetchInvoice: () => {
      dispatch(fetchInvoice(ownProps.invoiceId));
    },
    delete: invoiceId => {
      dispatch(deleteProductInvoice(ownProps.invoiceId, ownProps.vehicleId, ownProps.invoice?.direction));
    },
    deleteSubject: subjectId => {
      dispatch(removeInvoiceSubject(subjectId, ownProps.invoiceId));
    },
    updateInvoice: dto => {
      dispatch(updateInvoice(ownProps.invoiceId, dto));
    },
    updateInvoiceEmailData: (dto, callback) => {
      dispatch(updateInvoiceEmailData(ownProps.invoiceId, dto, callback));
    },
    finalizeV2() {
      dispatch(finalizeV2(ownProps.invoiceId));
    },
    retryFinalizationV2() {
      dispatch(retryFinalizationV2(ownProps.invoiceId));
    },
    addApiError(msg) {
      dispatch(addApiError(msg));
    },
    createCreditInvoice(callback) {
      dispatch(createCreditInvoice(ownProps.invoiceId, callback));
    },
    deleteInvoice(properties, callback, vehicleId) {
      dispatch(deleteInvoice(ownProps.invoiceId, callback, properties, vehicleId));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const ProductInvoice = compose(withConnect, withRouter, injectIntl)(ProductInvoiceComp);
